import { render, staticRenderFns } from "./GamePlan1.vue?vue&type=template&id=58bcc754&"
import script from "./GamePlan1.vue?vue&type=script&lang=js&"
export * from "./GamePlan1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports